import { createSelector } from "reselect";
import _ from "lodash";
import Colors from "../config/colors";
import { parseLocationIdentifier } from "../helpers/location";

const locationsSelector = createSelector(
  (state) => state.jobReducer.data,
  (data) => {
    if (!data.input || !data.network || !data.output.solution) {
      return [];
    }
    const {
      network,
      input: { fleet, visits },
      output: { solution },
    } = data;
    let {
      output: { unserved },
    } = data;

    const results = [];
    const totalColors = Colors.random.length;

    let vSolution = [];

    Object.keys(solution).forEach((vehicleId, vIndex) => {
      vSolution = solution[vehicleId];

      if (vSolution.length === 0) {
        const vehicle = fleet[vehicleId];
        const startLocation = vehicle.start_location || {};
        vSolution.push({
          location_id: startLocation.id,
          location_name: startLocation.name,
          type: vehicle.type,
        });
      }

      vSolution.forEach((vs, number) => {
        const { baseId, locationType } = parseLocationIdentifier(
          vs.location_id
        );
        const vType = locationType || vs.type || "dropoff";
        const vNetwork =
          network[vs.location_id] || network[`${vs.location_id}_${vType}`];
        const vLocation = visits[baseId] || visits[vs.location_id] || {};
        let fleetInfo = {};
        const isStartingLocation = number === 0;
        if (isStartingLocation) {
          fleetInfo = {
            shift_start: fleet[vehicleId].shift_start,
            shift_end: fleet[vehicleId].shift_end,
            breaks: fleet[vehicleId].breaks || [],
            type: fleet[vehicleId].type || [],
          };
        }

        if (vNetwork && vNetwork.lat && vNetwork.lng) {
          results.push({
            ...vs,
            ...vNetwork,
            ...vLocation,
            ...fleetInfo,
            ...vLocation[vType],
            vType: vType,
            number,
            vehicleId,
            zIndex: 999999 - (30 * (number % 3) + vIndex),
            color: Colors.random[vIndex % totalColors],
            isStartingLocation,
            isLastLocation: !vSolution[number + 1],
            isVisit: vSolution[0].location_id !== vs.location_id,
          });
        }
      });
    });

    results.push({
      location_id: "",
      location_name: "",
      vehicleId: "unserved",
      number: 0,
      zIndex: 1,
      color: "C4C4C4",
      isLastLocation: false,
      isStartingLocation: true,
      isVisit: false,
    });

    if (!!unserved) {
      if (_.isArray(unserved)) {
        const unservedTmp = {};
        unserved.forEach((visitId) => {
          unservedTmp[visitId] =
            "Sorry, none of the stops can be scheduled. Please check your inputs and constraints.";
        });
        unserved = unservedTmp;
      }
      let number = 0;
      _.keys(unserved).forEach((visitId) => {
        const stops = [];
        const visit = visits[visitId];

        stops.push({ ...visit, ...(visit?.dropoff || {}), vType: "dropoff" });

        _.each(stops, (s) => {
          const vNetwork =
            network[visitId] || network[`${visitId}_${s.vType}`] || {};
          number++;
          results.push({
            ...vNetwork,
            ...s,
            type: s.vType,
            location_id: visitId,
            location_name: vNetwork.name || visitId,
            vehicleId: "unserved",
            number: number,
            zIndex: number + 1,
            color: "C4C4C4",
            isLastLocation: false,
            isStartingLocation: false,
            isVisit: true,
            unservedReason: unserved[visitId],
          });
        });
      });
    }
    return results;
  }
);

export default locationsSelector;
